import { render } from "./ForgotPasswordProcess.vue?vue&type=template&id=166b32f5"
import script from "./ForgotPasswordProcess.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__